module.exports = __webpack_public_path__ + "img/desk.4bef8d0a.png";